import { createFileRoute } from '@tanstack/react-router';
import { WorkSheetDetailPage } from '@/features/work-orders/components/worksheet-detail/WorkSheetDetailPage';

export const Route = createFileRoute('/_authenticated/work-orders/$id/worksheets/$worksheetId/')({
	component: WorkSheetDetail,
});

function WorkSheetDetail() {
	const { id, worksheetId } = Route.useParams();
	return <WorkSheetDetailPage workOrderId={id} worksheetId={worksheetId} />;
}
